<template>
  <j-modal
    :title="title"
    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    :okText="this.$store.getters.language['common.okButton']"
    :ok-disabled="disableSubmit"
    @cancel="handleCancel"
    :okButtonProps="{ props: {disabled: disabled} }"
    :cancelText="language['common.closeButton']">

    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" :model="model" :rules="validatorRules">
        <a-row style="width: 100%;">
          <a-col :span="24/2">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              prop="titile"
              :label="language['announcement.header']">
              <a-input :placeholder="language['announcement.mustHeader']" v-model="model.titile" :maxLength="99" :disabled="disableSubmit"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24/2">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              prop="msgCategory"
              :label="language['announcement.msgCategory']">
              <a-select
                v-model="model.msgCategory"
                @change="categoryChange"
                :placeholder="language['common.pleaseChoose']+language['announcement.msgCategory']"
                :disabled="disableSubmit"
                :getPopupContainer = "(target) => target.parentNode">
                <a-select-option value="1">{{language['announcement.notification']}}</a-select-option>
                <a-select-option value="2">{{language['announcement.systemMessages']}}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style="width: 100%;">
          <a-col :span="24/2">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              prop="startTime"
              :label="language['common.beginTime']+':'">
              <j-date style="width: 100%" :getCalendarContainer="node => node.parentNode"
                      :disabled="disableSubmit"
                      @change="startTimeChange"
                      v-model="model.startTime"  :placeholder="language['common.choosebeginTime']" showTime dateFormat="YYYY-MM-DD HH:mm:ss" ></j-date>
            </a-form-model-item>
          </a-col>
          <a-col :span="24/2">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              prop="endTime"
              :label="language['common.endTime']"
              class="endTime">
              <j-date style="width: 100%" :getCalendarContainer="node => node.parentNode" v-model="model.endTime"
                      :disabled="disableSubmit"
                      @change="endTimeChange"
                      :placeholder="language['common.pleaseChoose']+language['common.endTime']" showTime dateFormat="YYYY-MM-DD HH:mm:ss"></j-date>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style="width: 100%;">
          <a-col :span="24/2">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              :label="language['announcement.priority']">
              <a-select
                v-model="model.priority"
                :placeholder="language['common.pleaseChoose']+language['announcement.priority']"
                :disabled="disableSubmit"
                :getPopupContainer = "(target) => target.parentNode">
                <a-select-option value="L">{{language['common.low']}}</a-select-option>
                <a-select-option value="M">{{language['common.middle']}}</a-select-option>
                <a-select-option value="H">{{language['common.high']}}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            :label="language['system.announcement.needReply']">
              <j-dict-select-tag type="radio" v-model="model.needReply" :trigger-change="true" :disabled="disableSubmit" dictCode="platform_anno_need_reply" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style="width: 100%;">
          <a-col :span="12">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              :label="language['system.announcement.needSendMail']">
              <j-dict-select-tag type="radio" v-model="model.needSendMail" @change="needSendMailChange"
                                 :trigger-change="true" :disabled="disableSubmit" dictCode="platform_anno_need_send_mail" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              v-if="model.needSendMail==1"
              :label="language['system.announcement.isSendMailNow']">
              <a-radio-group  v-model="isSendMailNowValue"   :disabled="disableSubmit">
                <a-radio :value="'0'">{{ language['common.no'] }}</a-radio>
                <a-radio :value="'1'">{{ language['common.yes'] }}</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style="width: 100%;">
          <a-col :span="24/2">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              prop="applicationId"
              :label="language['application']">
              <a-select
                allowClear
                :getPopupContainer = "(target) => target.parentNode"
                @change="applicationChange"
                v-model="model.applicationId"
                :options="applicationOptions"
                :disabled="disableSubmit?disableSubmit:$store.getters.application.applicationType !== 'platform'"
                :placeholder="language['common.pleaseChoose']+language['application']">
              </a-select>
            </a-form-model-item>
          </a-col>

          <!--劳安专用-->
          <a-col :span="24"></a-col>
          <span v-if="showLaborPart">
            <a-col :span="24/2">
              <a-form-model-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                prop="laborAnnounceCategory"
                :label="language['system.labor.notice.category']"><!--公告類型-->
                <j-dict-select-tag v-model="model.laborAnnounceCategory" dictCode="labor_announce_category" :placeholder="language['common.pleaseChoose']+language['system.labor.notice.category']" :disabled="disableSubmit"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="24/2">
              <a-form-model-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                prop="laborAnnounceEntity"
                :label="language['system.labor.notice.object']"><!--公告對象-->
                <j-dict-select-tag v-model="model.laborAnnounceEntity" dictCode="labor_announce_entity" :placeholder="language['common.pleaseChoose']+language['system.labor.notice.object']" :disabled="disableSubmit"/>
              </a-form-model-item>
            </a-col>
          </span>
          <!--劳安专用-->

          <a-col :span="24/2">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              v-if="secondMsgCategoryShow"
              :label="this.$store.getters.language['announcement.secondMsgCategory']">
<!--              <a-select
                allowClear
                :getPopupContainer = "(target) => target.parentNode"
                @change="applicationChange"
                v-model="model.applicationId"
                :options="applicationOptions"
                :disabled="disableSubmit?disableSubmit:$store.getters.application.applicationType !== 'platform'"
                :placeholder="language['common.pleaseChoose']+language['application']">
              </a-select>-->
              <a-select v-model="secondMsgCategoryValue"
                        allowClear :disabled="disableSubmit"
                        :getPopupContainer = "(target) => target.parentNode"
              >
                <a-select-option v-for="(item,index) in secondMsgCategorylist"
                                 :key="index"
                                 :value="item.code">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row v-if="model.applicationId">
          <a-col :span="24/2">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              prop="msgType"
              v-if="model.applicationId"
              :label="language['announcement.msgType']">
              <a-select
                v-model="model.msgType"
                :placeholder="language['common.pleaseChoose']+language['announcement.msgType']"
                :disabled="disableSubmit"
                @change="chooseMsgType"
               > <!--:getPopupContainer = "(target) => target.parentNode"-->
                <a-select-option value="USER">{{language['announcement.appointUser']}}</a-select-option>
                <!--<a-select-option value="APPLICATION">指定应用</a-select-option>-->
                <!--<a-select-option value="ALL">全体用户</a-select-option>-->
                <a-select-option value="APPLICATION">{{language['announcement.allUser']}}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col :span="24/2">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              :label="language['announcement.appointUser']"
              prop="validateSelectedUser"
              v-if="model.msgType==='USER'">
              <a-select
                mode="multiple"
                :placeholder="language['common.pleaseChoose']+language['user']"
                :labelInValue=true
                v-model="selectedUser"
                :disabled="disableSubmit"
                @dropdownVisibleChange="selectUserIds"
                @change="handleChange"
              >
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style="width: 100%;">
          <a-col :span="24">
            <a-form-model-item
              :labelCol="labelColX1"
              :wrapperCol="wrapperColX1"
              prop="msgAbstract"
              :label="language['announcement.msgAbstract']">
              <a-textarea :placeholder="language['common.pleaseInput']+language['announcement.msgAbstract']"  v-model="model.msgAbstract" :disabled="disableSubmit" :maxLength="20000"/>
            </a-form-model-item>
          </a-col>
          <!--<a-col :span="24/2">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="指定用户"
              v-if="userType">
              <a-select
                mode="multiple"
                placeholder="请选择用户"
                :labelInValue=true
                v-model="selectedUser"
                @dropdownVisibleChange="selectUserIds"
                @change="handleChange"
              >
              </a-select>
            </a-form-model-item>
          </a-col>-->
          <!--<a-col :span="24/2">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="指定应用"
              v-if="applicationType">
              <j-multi-select-tag
                v-model="model.applicationId"
                :options="applicationOptions"
                placeholder="请选择指定应用">
              </j-multi-select-tag>
            </a-form-model-item>
          </a-col>-->
        </a-row>
        <a-row style="width: 100%;">
          <a-col :span="24">
            <a-form-model-item
              :labelCol="labelColX1"
              :wrapperCol="wrapperColX1"
              :label="language['announcement.msgContent']"
              class="j-field-content">
              <j-editor v-model="model.msgContent" :disabled="disableSubmit"></j-editor>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-tab-pane :tab="language['selfCheck.ref.file']" :key="refKeys[0]" :forceRender="true" v-if="uploadSource">
          <j-editable-table
            :uploadSource="uploadSource"
            :ref="refKeys[0]"
            :loading="announcementFileTable.loading"
            :columns="announcementFileTable.columns"
            :dataSource="announcementFileTable.dataSource"
            :maxHeight="300"
            :maxNumber="10000"
            :disabled="disableSubmit?disableSubmit:formDisabled"
            :rowNumber="true"
            :is-show-download-button="false"
            :rowSelection="true"
            :actionButton="true"/>
        </a-tab-pane>

      </a-form-model>
    </a-spin>
    <select-user-list-modal ref="UserListModal" @choseUser="choseUser"></select-user-list-modal>
  </j-modal>
</template>

<script>
  import { httpAction,getAction } from '@/api/manage'
  import { get, pick } from 'lodash';
  import {applicationList} from '@/api/api'
  import JDate from '@/components/jeecg/JDate'
  import JEditor from '@/components/jeecg/JEditor'
  import SelectUserListModal from "./SelectUserListModal";
  import moment from 'moment'
  import { FormTypes,getRefPromise,VALIDATE_NO_PASSED,validateFormModelAndTables } from '@/utils/JEditableTableUtil'
  import { JEditableTableModelMixin } from '@/mixins/JEditableTableModelMixin'
  import ARow from "ant-design-vue/es/grid/Row";

  export default {
    components: {ARow, JEditor, JDate, SelectUserListModal},
    mixins: [JEditableTableModelMixin],
    name: "SysAnnouncementModal",
    data () {
      return {
        refKeys: ['announcementFile', ],
        tableKeys:['announcementFile', ],
        activeKey: 'announcementFile',
        // 相关附件
        announcementFileTable: {
          loading: false,
          dataSource: [],
          columns: [
            {
              title: this.$store.getters.language['common.fileName'],
              key: 'fileName',
              type: FormTypes.file,
              token:true,
              responseName:"message",
              width:"200px",
              placeholder: this.$store.getters.language['common.pleaseChoose']+this.$store.getters.language['common.file'],
              defaultValue:'',
              validateRules: [{ required: true, message: '${title}'+this.$store.getters.language['common.cannotEmpty'] }],
            },
            {
              title: this.$store.getters.language['common.file']+this.$store.getters.language['common.desc'],
              key: 'fileDesc',
              type: FormTypes.input,
              width:"200px",
              placeholder: this.$store.getters.language['common.pleaseInput']+'${title}',
              defaultValue:'',
            },
          ]
        },
        receiverType: "",
        applicationOptions:[],
        applicationAll:[],
        title:this.$store.getters.language["common.action"],
        visible: false,
        disableSubmit:false,
        model: {
          laborAnnounceCategory: null,
          laborAnnounceEntity: null,
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 18 },
        },
        labelColX1: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperColX1: {
          xs: { span: 24 },
          sm: { span: 21 },
        },
        confirmLoading: false,
        validatorRules:{
          titile: [{ required: true, message: this.$store.getters.language['announcement.mustHeader'] }],
          msgCategory: [{ required: true, message: this.$store.getters.language['common.pleaseChoose']+this.$store.getters.language['announcement.msgCategory'] }],
          msgType:[{ required: true, message: this.$store.getters.language['common.pleaseChoose']+this.$store.getters.language['announcement.msgType'] }],
          applicationId:[{required: true, message: this.$store.getters.language['common.pleaseChoose']+this.$store.getters.language['application']}],
          endTime:[{ required: true, message: this.$store.getters.language['common.pleaseChoose']+this.$store.getters.language['common.endTime']} ,{validator: this.endTimeValidate}],
          startTime:[{required: true, message: this.$store.getters.language['common.pleaseChoose']+this.$store.getters.language['common.beginTime']},{validator: this.startTimeValidate}],
          msgAbstract: [{ required: true, message: this.$store.getters.language['common.pleaseInput']+this.$store.getters.language['announcement.msgAbstract'] }],
          validateSelectedUser:[{validator: this.selectedUserValidate}],
          laborAnnounceCategory:[{ required: true, message: this.$store.getters.language['common.cannotEmpty'] }],
          laborAnnounceEntity:[{ required: true, message: this.$store.getters.language['common.cannotEmpty'] }],
        },
        url: {
          queryByIds: "/sys/user/queryByIds",
          add: "/sys/annountCement/add",
          edit: "/sys/annountCement/edit",
          announcementFile: {
            list: '/sys/sysAnnouncementFile/queryAnnouncementFileById'
          },
        },
        userType:false,
        applicationType:false,
        userIds:[],
        selectedUser:[],
        disabled:false,
        msgContent:"",
        userList:[],
        uploadSource:'',
        secondMsgCategorylist:[],
        secondMsgCategoryShow:false,
        secondMsgCategoryValue:'',
        isSendMailNowValue:'',
        showLaborPart: false,
      }
    },
    created () {
      this.initApplicationList();
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      formDisabled(){
        return this.disabled
      },
    },
    methods: {
      categoryChange(){
        this.secondMsgCategoryValue = null;
        this.initSecondMsgCategorylist();
      },
      applicationChange(value){
        // this.model.msgType = ''
        this.selectedUser = []
        this.userIds =[]
        if(value !== ''){
          this.showLaborPart = false;
          for(let i=0;i<this.applicationAll.length;i++){
            let item = this.applicationAll[i];
            let applicationCode = item.applicationCode;
            if(value == item.id){
              if(applicationCode === 'labor'){
                this.showLaborPart = true;
              }
              this.uploadSource = applicationCode;
              break;
            }
          }
        }else{
          this.uploadSource = '';
          this.showLaborPart = false;
        }
        this.secondMsgCategoryValue = null;
        this.initSecondMsgCategorylist();
      },
      /** 整理成formData */
      classifyIntoFormData(allValues) {
        let main = Object.assign(this.model, allValues.formValue)
        return {
          ...main, // 展开
          announcementFileList: allValues.tablesValue[0].values
        }
      },
      //初始化应用数据
      initApplicationList(){
        applicationList().then((res) => {
          if(res.success){
            this.applicationAll = res.result;
            this.applicationOptions = res.result.map((item,index,arr)=>{
              let c = {label:item.applicationName, value:item.id}
              return c;
            })
            console.log('this.applicationOptions: ',this.applicationOptions)
          }
        })
      },
      initSecondMsgCategorylist(){
        // this.secondMsgCategorylist = [];
        this.secondMsgCategoryShow = false;
        if(this.model.applicationId&&this.model.msgCategory){
          getAction("/sys/sysleveldataconfigs/getDataByEntity",{applicationId:this.model.applicationId,dataTypeCode:'announcement_management',parentCode:this.model.msgCategory}).then(res=>{
            if(res.success){
              this.secondMsgCategorylist = res.result;
              this.secondMsgCategoryShow = true;
            }else{
              this.secondMsgCategorylist = [];
            }
          })
        }
      },
      secondMsgCategoryChange(value){
        // this.model.secondMsgCategory = value;
      },
      needSendMailChange(value){
        if(this.model.needSendMail == '1'){
          this.isSendMailNowValue = '0';
        }else{
          this.isSendMailNowValue = ''
        }
      },
      add () {
        this.announcementFileTable = {
            loading: false,
            dataSource: [],
            columns: [
              {
                title: this.$store.getters.language['common.fileName'],
                key: 'fileName',
                type: FormTypes.file,
                token:true,
                responseName:"message",
                width:"200px",
                placeholder: this.$store.getters.language['common.pleaseChoose']+this.$store.getters.language['common.file'],
                defaultValue:'',
                validateRules: [{ required: true, message: '${title}'+this.$store.getters.language['common.cannotEmpty'] }],
              },
              {
                title: this.$store.getters.language['common.file']+this.$store.getters.language['common.desc'],
                key: 'fileDesc',
                type: FormTypes.input,
                width:"200px",
                placeholder: this.$store.getters.language['common.pleaseInput']+'${title}',
                defaultValue:'',
              },
            ]
        };
        this.showLaborPart = false;
        if(this.$store.getters.application.applicationType !== 'platform') {
          this.edit({applicationId:this.$store.getters.application.id,needReply:'0',needSendMail:'0'});
          // this.model.applicationId = this.$store.getters.application.id;
        }else{
          this.edit({needReply:'0',needSendMail:'0'});
        }
      },
      edit (record) {
        this.model = {}
        this.disable = false;
        this.showLaborPart = false;
        this.visible = true;
        if(record.msgType == 'APPLICATION'){
          this.applicationType = true;
        }
        this.model = Object.assign({}, record);
        if(this.model.isSendMailNow){
          this.isSendMailNowValue = this.model.isSendMailNow
        }
        if(this.model.applicationId){
          getAction("/sys/sysBmApplication/queryById", {id:this.model.applicationId}).then((res) => {
            if (res.success) {
              this.uploadSource = res.result.applicationCode
              if(this.uploadSource === 'labor'){
                this.showLaborPart = true;
              }
            }
          })
        }else{
          this.uploadSource = "";
        }
        /*let httpstr = this.Str_msgContent_toHttp(this.model.msgContent);
        this.model.msgContent = httpstr;*/
        this.getUser(record);
        this.$nextTick(() => {
          // 加载子表数据
          if (this.model.id) {
            let params = { id: this.model.id }
            this.requestSubTableData(this.url.announcementFile.list, params, this.announcementFileTable)
          }
        })
        this.initSecondMsgCategorylist();
        this.secondMsgCategoryValue = this.model.secondMsgCategory;
      },
      getUser(record){
        // 指定用户
        if(record&&record.msgType === "USER"){
          this.userType =  true;
          this.userIds = record.userIds;
          getAction(this.url.queryByIds,{userIds:this.userIds}).then((res)=>{
            if(res.success){
              //update--begin--autor:wangshuai-----date:20200601------for：系统公告选人后，不能删除------
              var userList=[];
              for(var i=0;i<res.result.length;i++){
                var user={};
                user.label =res.result[i].realname;
                user.key=res.result[i].id;
                userList.push(user);
              }
              this.selectedUser=userList;
              //update--begin--autor:wangshuai-----date:20200601------for：系统公告选人后，不能删除------
              this.$refs.UserListModal.edit(userList,this.userIds);
            }
          });
        }
      },
      close () {
        this.$emit('close');
        this.selectedUser = [];
        this.applicationType =  false;
        this.visible = false;
        this.userIds = [];
        this.files = "";
        this.msgContent = "";
        this.priority = "";
        this.$refs.form.resetFields();
        this.uploadSource = "";
      },
      Str_msgContent_toHttp(){
        let windowURL = window._CONFIG['domianURL'];
        if(this.model.msgContent){
          let str = this.model.msgContent;
          return this.funreplace(str,'/*httpurl*/',windowURL);
        }
        return "";
      },
      Http_msgContent_toStr(){
        let windowURL = window._CONFIG['domianURL'];
        if(this.model.msgContent){
          let str = this.model.msgContent;
          // let restr = str.replace(windowURL,'/*httpurl*/');
          return this.funreplace(str,windowURL,'/*httpurl*/');
        }
        return "";
      },
      funreplace(str,string,value){
        str = str.replace(string,value);
        if(str.indexOf(string)!=-1){
          str = this.funreplace(str,string,value)
        }
        return str;
      },
      handleOk () {
        const that = this;
        this.$refs.form.validate((valid,data) => {
          if (valid) {


        /*let str = this.Http_msgContent_toStr()
        that.model.msgContent = str;*/
        /** 触发表单验证 */
        this.getAllTable().then(tables => {
          return validateFormModelAndTables(this.$refs.form,this.model, tables)
        }).then(allValues => {
          /** 一次性验证一对一的所有子表 */
          return this.validateSubForm(allValues)
        }).then(allValues => {
          let formData = this.classifyIntoFormData(allValues)
          console.log("this.formData", formData)
          // 发起请求
          that.send(formData);
        })
          }
        })
      },
      send(formData){
        const that = this;
         //当设置指定用户类型，但用户为空时，后台报错
        if(this.userType &&!(this.userIds!=null && this.userIds.length >0)){
          this.$message.warning(this.language['announcement.appointUser']+this.language['common.cannotEmpty'])
          return;
        }
        if(this.applicationType && ((this.model.applicationId == null) || (this.model.applicationId == undefined))){
          this.$message.warning(this.language['announcement.appointApplication']+this.language['common.cannotEmpty'])
          return;
        }
        if(this.model.msgContent && this.model.msgContent.length > 20000){
          this.$message.warning(this.language['common.warning.contentTooLong']+','+this.language['common.max']+':20000');
          return;
        }
        // 触发表单验证
        that.confirmLoading = true;
        let httpurl = '';
        let method = 'post';
        if(!this.model.id){
          httpurl+=this.url.add;
          // method = 'post';
        }else{
          httpurl+=this.url.edit;
           // method = 'put';
        }
        if(this.userType){
          this.model.userIds =  this.userIds;
        }
        let fileList = formData.announcementFileList!= null?formData.announcementFileList:[];
        let flag = true;
        if(fileList && fileList.length>0){
          fileList.map(item => {
            if(item.fileDesc.length>199){
              this.$message.warning(item.fileName.substring(item.fileName.lastIndexOf("/")+1, item.fileName.length)+this.language['common.file']+this.language['common.desc']+this.language['common.overstep']+'200'+this.language['common.character']);
              flag = false;
              that.confirmLoading = false;
              return;
            }
          })
        }
        if(flag){
          this.model.files = JSON.stringify(fileList);
          /*if(this.receiverType != "APPLICATION"){
            this.model.applicationId = null;
          }*/
          this.model.secondMsgCategory = this.secondMsgCategoryValue
          this.model.isSendMailNow = this.isSendMailNowValue
          httpAction(httpurl,this.model,method).then((res)=>{
            if(res.success){
              that.$message.success(res.message);
              that.$emit('ok');
              that.resetUser();
            }else{
              that.$message.warning(res.message);
            }
          }).finally(() => {
            that.confirmLoading = false;
            that.close();
          })
        }
      },
      handleCancel () {
        this.visible = false;
        this.announcementFileTable = {
          loading: false,
          dataSource: [],
          columns: [
            {
              title: this.language['common.fileName'],
              key: 'fileName',
              type: FormTypes.file,
              token:true,
              responseName:"message",
              width:"200px",
              placeholder: this.$store.getters.language['common.pleaseChoose']+this.$store.getters.language['common.file'],
              defaultValue:'',
              validateRules: [{ required: true, message: this.$store.getters.language['common.pleaseInput']+'${title}' }],
            },
            {
              title: this.$store.getters.language['common.file']+this.$store.getters.language['common.desc'],
              key: 'fileDesc',
              type: FormTypes.input,
              width:"200px",
              placeholder: this.$store.getters.language['common.pleaseInput']+'${title}',
              defaultValue:'',
            },
          ]
        },

        this.$emit('close');
        this.$refs.form.resetFields();
        this.resetUser();
      },
      resetUser (){
        this.userType =  false;
        this.applicationType =  false;
        this.userIds = [];
        this.selectedUser = [];
        this.disabled = false;
        this.$refs.UserListModal.edit(null,null);
      },
      selectUserIds() {
        if(this.model.applicationId){
          this.$refs.UserListModal.applicationData.applicationBy='user';
          this.$refs.UserListModal.applicationData.selectedApplicationId = this.model.applicationId

        }
        this.$refs.UserListModal.add(this.selectedUser,this.userIds);
      },
      chooseMsgType(value) {
        this.receiverType = value;
        if("USER" == value) {
          this.userType = true;
          this.applicationType = false;
        } else if ("APPLICATION" == value){
          this.userType = false;
          this.applicationType = true;
          this.selectedUser = [];
          this.userIds = [];
        } else {
          this.userType = false;
          this.applicationType = false;
          this.selectedUser = [];
          this.userIds = [];
        }
      },
      // 子modal回调
      choseUser:function(userList){
        this.selectedUser = [];
        this.userIds = [];
        for(var i=0;i<userList.length;i++){
          //update--begin--autor:wangshuai-----date:20200601------for：系统公告选人后，不能删除------
          var user={};
          user.label =userList[i].realname;
          user.key=userList[i].id;
          this.selectedUser.push(user);
          //update--end--autor:wangshuai-----date:20200601------for：系统公告选人后，不能删除------
          if(this.userIds.length == 0){
            this.userIds += userList[i].id
          }else{
            this.userIds += ","+userList[i].id
          }
        }
        this.$refs.form.validateField(['validateSelectedUser'])
      },
      startTimeValidate(rule,value,callback){
        let endTime = this.model.endTime
        if(!value || !endTime){
          callback()
        }else if(moment(value).isBefore(endTime)){
          callback()
        }else{
          callback(this.language['system.beginTimeLessEndTime'])
        }
      },
      startTimeChange(){
        this.$refs.form.validateField(['endTime'])
      },
      endTimeValidate(rule,value,callback){
        let startTime = this.model.startTime;
        if(!value || !startTime){
          callback()
        }else if(moment(startTime).isBefore(value)){
          callback()
        }else{
          callback(this.language["system.endTimeGreaterBeginTime"])
        }
      },
      endTimeChange(){
        this.$refs.form.validateField(['startTime'])
      },
      selectedUserValidate(rule,value,callback){
        if(this.selectedUser.length==0){
          //selectedUser
          callback(this.$store.getters.language['announcement.appointUser']+this.$store.getters.language['common.cannotEmpty'])
        }else{
          callback()
        }
      },
      handleChange(userList) {
        if (userList) {
          this.userIds = [];
          var users=[];
          for (var i = 0; i < userList.length; i++) {
            var user={};
            user.id=userList[i].key;
            user.realname=userList[i].label;
            // this.userIds += userList[i].key + ',';
            if(this.userIds.length == 0){
              this.userIds += userList[i].key
            }else{
              this.userIds += ","+userList[i].key
            }
            users.push(user);
          }
        }
        if(this.model.applicationId){
          this.$refs.UserListModal.applicationData.applicationBy='user';
          this.$refs.UserListModal.applicationData.selectedApplicationId = this.model.applicationId

        }
        this.$refs.UserListModal.edit(users,this.userIds);
      },
      //校验所有一对一子表表单
      validateSubForm(allValues){
        return new Promise((resolve,reject)=>{
          Promise.all([
          ]).then(() => {
            resolve(allValues)
          }).catch(e => {
            if (e.error === VALIDATE_NO_PASSED) {
              // 如果有未通过表单验证的子表，就自动跳转到它所在的tab
              this.activeKey = e.index == null ? this.activeKey : this.refKeys[e.index]
            } else {
              console.error(e)
            }
          })
        })
      },
    }
  }
</script>

<style scoped>

</style>